<app-dialog class="delete-account-dialog" [hideClose]="true">
  <ng-container>
    <div class="header-close-wrapper">
      <h4 class="header">
        {{ 'module.userProfile.myPersonalData.deleteAccount.dialogHeaderText' | translate }}
      </h4>
      <span class="fa fa-times" (click)="closeModal()"></span>
    </div>
  </ng-container>

  <div class="delete-account-content">
    <ng-container>
      <p class="description-text top-margin">
        {{ 'module.userProfile.myPersonalData.deleteAccount.dialogDescriptionText' | translate }}
      </p>
      <p class="description-text bullet-point">
        &bull;
        {{ 'module.userProfile.myPersonalData.deleteAccount.dialogFirstBulletText' | translate }}
      </p>
      <p class="description-text bullet-point">
        &bull;
        {{ 'module.userProfile.myPersonalData.deleteAccount.dialogSecondBulletText' | translate }}
      </p>
    </ng-container>
    <ng-container>
      <p class="description-text top-margin-email-text">
        {{ 'module.userProfile.myPersonalData.deleteAccount.dialogEnterEmailText' | translate }}
      </p>
      <form [formGroup]="emailForm">
        <mat-form-field class="form-field-wrapper" appearance="none">
          <input
            title="email"
            matInput
            type="email"
            formControlName="emailControl"
            class="form-control"
            [ngClass]="{
              'error-border': emailForm.get('emailControl')?.invalid && (emailForm.get('emailControl')?.dirty || emailForm.get('emailControl')?.touched),
              'clear-border': !emailForm.get('emailControl')?.invalid
            }"
          />
          <mat-error class="error-message-color" *ngIf="emailForm.get('emailControl')?.errors">
            {{ formControlError.message }}
          </mat-error>
        </mat-form-field>
      </form>
      <p class="reminder">
        {{ 'module.userProfile.myPersonalData.deleteAccount.dialogReminderText' | translate }}
      </p>
      <div class="button-wrapper">
        <button [ngClass]="{ '-disabled': emailForm.invalid }" class="btn delete-btn" [disabled]="emailForm.invalid" (click)="deleteAccount()">
          {{ 'module.userProfile.myPersonalData.deleteAccount.dialogDeleteButtonText' | translate }}
        </button>
        <button class="btn btn-outline-primary close-btn" (click)="closeModal()">
          {{ 'module.userProfile.myPersonalData.deleteAccount.dialogCancelButtonText' | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</app-dialog>
